import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../config";
import {
  planExportRun,
  createExportRun,
  getRunDetail,
  getRunsHistory,
  cancelRun,
} from "../requests/runs.requests";
import { RunCreateInput } from "../../types/run";

export const usePlanExportRun = () => {
  return useMutation({
    mutationFn: (input: RunCreateInput) => planExportRun(input),
  });
};

export const useCreateExportRun = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: RunCreateInput) => createExportRun(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RUNS_HISTORY] });
    },
  });
};

export const useGetRunDetail = (runId: string, enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.RUN_DETAIL, runId],
    queryFn: () => getRunDetail(runId),
    enabled: enabled && !!runId,
    refetchInterval: (query) => {
      const isTerminal = query.state.data?.status.is_terminal;
      if (isTerminal === false) return 3000;
      return false;
    },
  });
};

export const useGetRunsHistory = (limit?: number) => {
  return useQuery({
    queryKey: [QUERY_KEYS.RUNS_HISTORY, limit],
    queryFn: () => getRunsHistory(limit),
  });
};

export const useCancelRun = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (runId: string) => cancelRun(runId),
    onSuccess: (_data, runId) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RUN_DETAIL, runId] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RUNS_HISTORY] });
    },
  });
};
